import { useCallback, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { panelPublicUrl } from "../../../panelurl"
import CommandCenterService from "../../../service/CommandCenterService"
import useScenario from "./useScenario"
import useUrlParams from "./useUrlParams"

const useMonitor = () => {
    const { loading, scenario, set_telemetry_time, telemetry_time, } = useScenario()
    const { truetwin_id, scenario_id } = useUrlParams()

    const [selected_panel, set_selected_panel] = useState<string>('EPS')
    const [monitor_view_type, set_monitor_view_type] = useState<string>('Grid')
    const [grafana_data, set_grafana_data] = useState<any>({})
    const [panels, set_panels] = useState<any | null>(null)


    useEffect(() => {
        if (scenario?.['grafanaData']) {
            const grafana_data = scenario?.['grafanaData']?.['Urls']
            set_grafana_data(grafana_data)
            set_panels(grafana_data?.['EPS'])
            set_selected_panel('EPS')
            change_monitor_view_type('Grid')
        }
    }, [scenario])
    const [fileName, setFileName] = useState('');


    const handleFileUpload = () => {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.txt'; // Accept only .txt files
        fileInput.onchange = (event: any) => {
            const file = event.target.files[0];
            if (file && file.type === 'text/plain') {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    if (!e) return;
                    const uploadFile = e.target.result;
                    const blob = new Blob([uploadFile], { type: "multipart/form-data" });
                    const file_data = new FormData();
                    file_data.append("file", blob, file.name);
                    file_data.append("scenarioId", scenario_id as string);
                    file_data.append("trueTwinId", truetwin_id as string);
                    file_data.append("bandType", "Backdoor");
                    file_data.append("insertTime", "")
                    file_data.append("groundStationId", "")
                    // Call the upload API with the FormData object
                    setFileName(file.name);
                    uploadAPI(file_data);
                };
                reader.readAsText(file);
            } else {
                console.error('Invalid file format');
                toast.error('Invalid file format. Please upload a .txt file.', { toastId: '0' });
            }
        };
        fileInput.click();
    };

    const uploadAPI = (file_data) => {
        CommandCenterService.postUploadFileConsoleFlatSatTele(file_data)
            .then((response) => {
                if (response) {
                    setFileName('')

                    toast.success('File uploaded successfully.', { toastId: '0' });
                } else {
                    toast.error('File upload failed.', { toastId: '0' });
                }
            })
            .catch((error) => {
                console.error('Error uploading file:', error);
                toast.error('Error uploading file. Please try again.', { toastId: '0' });
            })
            .finally(() => {
                console.log('Upload process finished.');
            });
    };

    const change_selected_panel = (panel: string) => {
        if (panel === 'Communication') {
            set_panels(grafana_data?.['Comms'])
            set_selected_panel(panel)
            return
        } else if (panel === 'Payload') {
            set_panels(grafana_data?.['PAYLOAD']?.['PayloadApp'])
            set_selected_panel(panel)
            return
        } else {
            set_panels(grafana_data?.[panel])
            set_selected_panel(panel)
            return
        }
    }

    const change_monitor_view_type = (view: string) => {
        set_monitor_view_type(view)
    }

    function updateUrlsWithTimeRange(url: string, from: number | string, to: number | string) {
        const updatedUrl = url.split('from')[0]
        return `${updatedUrl}&from=${from}&to=${to}`; // Create a new object with the updated URL
    }

    const get_updated_url = useCallback((url: string) => {
        if (telemetry_time && telemetry_time[0] && telemetry_time[1]) {
            const from = telemetry_time[0]?.getTime()
            const to = telemetry_time[1]?.getTime()
            const updated_url = updateUrlsWithTimeRange(url, from, to)
            return updated_url
        } else {
            return url
        }
    }, [telemetry_time])

    return {
        panels,
        loading,
        selected_panel,
        telemetry_time,
        get_updated_url,
        set_telemetry_time,
        change_selected_panel,
        monitor_view_type,
        change_monitor_view_type,
        handleFileUpload,
        fileName,
    }
}

export default useMonitor